const FRAMES = []
const DATA_SET = 'data-v-el-resize-id'
const NAME = 'v-el-resize'

/**
 * @desc Bind hook
 * @param el { HTMLElement }
 * @param value { Function }
 */
function bind (el, { value }) {
  const iFrame = document.createElement('iframe')
  const configFrame = prepareIFrameConfig(iFrame, value)

  setStylesIFrame(iFrame)
  FRAMES.push(configFrame)

  iFrame.onload = () => {
    iFrame.contentWindow.addEventListener('resize', configFrame.handler)
  }

  el.appendChild(iFrame)
  el.setAttribute(DATA_SET, configFrame.index)
}

/**
 * @desc Unbind hook
 * @param el { HTMLElement }
 */
function unbind (el) {
  let { index } = FRAMES.find(item => String(item.index) === el.getAttribute(DATA_SET))
  FRAMES.splice(index, 1)
}

/**
 * @desc Resize event for iFrame
 * @param e { Event }
 * @param bindHandler { Function }
 * @param iFrame { HTMLElement }
 */
function eventResize (e, { bindHandler, iFrame }) {
  bindHandler(iFrame)
}

/**
 * @desc Prepare config for frame
 * @param iFrame
 * @param bindHandler
 * @returns {{handler: handler, bindHandler: *, iFrame: *, index: *}}
 */
function prepareIFrameConfig (iFrame, bindHandler) {
  if (typeof bindHandler !== 'function') {
    throw new Error(`${NAME} => binding value must be a function`)
  }
  const config = {
    index: new Date().getUTCMilliseconds(),
    handler: function (e) { eventResize(e, config) },
    iFrame,
    bindHandler
  }
  return config
}
/**
 * @desc Set styles for iFrame
 * @param iFrame { HTMLElement }
 * @returns { HTMLElement<iFrame> }
 */
function setStylesIFrame (iFrame) {
  iFrame.setAttribute('width', '100%')
  iFrame.setAttribute('height', '100%')
  iFrame.style.position = 'absolute'
  iFrame.style.top = '0px'
  iFrame.style.right = '0px'
  iFrame.style.bottom = '0px'
  iFrame.style.left = '0px'
  iFrame.style.zIndex = '-1'
  return iFrame
}
export default {
  bind,
  unbind
}
